module.exports = __webpack_public_path__ + "img/num_20.c99d71b4.png";